export const ROAD = {
  LENGTH: { NONE: 0, SHORT: 25, MEDIUM: 50, LONG: 110 },
  HILL: { NONE: 0, LOW: 20, MEDIUM: 45, HIGH: 70 },
  CURVE: { NONE: 0, EASY: 3, MEDIUM: 4, HARD: 6 },
};
export let segmentLength = 200; // length of a single segment
export let rumbleLength = 3; // number of segments per red/white rumble strip

// export const link_comp = 'http://localhost:3000';
export const link_comp = '/game-lobby';

// local: '' or 'http://localhost:3000'
// deploy 'https://stacksdegens.com/game-lobby'
